// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_ed-0";